import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { AuthContext } from '../App';

export default function SignupPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', email: '', password: '', display_name: '', is_streamer: false, invite_code: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.signup(form);
      login(res.token, res.user);
      navigate(form.is_streamer ? '/dashboard' : '/');
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Join Ninty</h1>
        <p>Create your account and start streaming or watching</p>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>Invite Code</label>
            <input className="input" placeholder="Enter your invite code" value={form.invite_code} onChange={e => set('invite_code', e.target.value)} required />
            <div style={{ fontSize: '0.72rem', color: '#adadb8', marginTop: '4px' }}>Ninty is in early access. Need a code? Contact us.</div>
          </div>
          <div className="form-group">
            <label>Username</label>
            <input className="input" placeholder="e.g. coolstreamer" value={form.username} onChange={e => set('username', e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input className="input" type="email" value={form.email} onChange={e => set('email', e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input className="input" type={showPw ? 'text' : 'password'} value={form.password} onChange={e => set('password', e.target.value)} required minLength={8} style={{ paddingRight: '40px', marginBottom: 0 }} />
              <button type="button" onClick={() => setShowPw(!showPw)}
                style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#adadb8', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'var(--font-pixel)', padding: '4px' }}>
                {showPw ? 'o.o' : '-.-'}
              </button>
            </div>
            <div style={{ fontSize: '0.72rem', color: '#adadb8', marginTop: '6px', lineHeight: 1.5 }}>
              {form.password.length > 0 ? (
                <span style={{ color: form.password.length >= 8 ? '#00c400' : '#eb0400' }}>
                  {form.password.length >= 8 ? '✓' : '✗'} Minimum 8 characters ({form.password.length}/8)
                </span>
              ) : (
                'Must be at least 8 characters'
              )}
            </div>
          </div>
          <div className="toggle-row">
            <button type="button" className={`toggle ${form.is_streamer ? 'on' : ''}`} onClick={() => set('is_streamer', !form.is_streamer)} />
            <span>I want to stream content</span>
          </div>
          {form.is_streamer && (
            <div style={{ background: '#D6E9AA11', border: '1px solid #D6E9AA33', borderRadius: '8px', padding: '12px', marginBottom: '16px', fontSize: '0.85rem', color: '#adadb8' }}>
              💜 As a streamer, you keep <strong style={{ color: '#D6E9AA' }}>90%</strong> of all tips and subscriptions. 5% supports charities, 5% keeps the platform running.
            </div>
          )}
          <button className="btn btn-primary" style={{ width: '100%', padding: '12px' }} disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
        <div className="auth-switch">
          Already have an account? <Link to="/login">Log in</Link>
        </div>
      </div>
    </div>
  );
}
